// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"deef1ec7","202":"9534bbe1","422":"1587fb36","811":"02c34490","842":"c6d13ee2"}[chunkId] + ".chunk.js";
};